import script from "./mark-failed-button.vue?vue&type=script&lang=js"
export * from "./mark-failed-button.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__